'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.setPrototypeOf')} */
module.exports = $Object.setPrototypeOf || null;



//////////////////
// WEBPACK FOOTER
// ./~/set-proto/Object.setPrototypeOf.js
// module id = 1876
// module chunks = 1